class CompareProducts extends HTMLElement {
    constructor() {
        super();
        this.cardTemplate = document.getElementById('cardTemplate').textContent;
        this.cardEmptyTemplate = document.getElementById('cardEmptyTemplate').textContent;
        this.compareEmptyTemplate = document.getElementById('compareEmptyTemplate').textContent;
        this.init();
    }

    async init() {
        const prodsUrls = this.getProductUrls();
        if (prodsUrls.length > 0) {
            await this.displayDataInTable(...prodsUrls);
        } else {
            this.innerHTML = this.compareEmptyTemplate;
        }
    }

    getProductUrls() {
        const queryString = window.location.search;
        const searchParams = new URLSearchParams(queryString);
        if (!searchParams.has('prods') || searchParams.get('prods').trim() === '') {
            console.error("No 'prods' parameter found in the current URL.");
            return [];
        }
        let prodsParamValue = searchParams.get('prods');
        const productNamesArray = prodsParamValue.split(',').filter((name) => name.trim() !== '');
        this.handleCount = productNamesArray.length;
        return productNamesArray.map((name) => `/products/${name.trim()}?view=compare`);
    }

    setupRemoveButtonHandler() {
        // Find all buttons within the component
        const buttons = this.querySelectorAll('button[data-handle]');

        // Attach an onclick event handler to each button
        buttons.forEach((button) => {
            button.onclick = () => this.handleRemoveButtonClick(button.dataset.handle);
        });
    }

    handleRemoveButtonClick(handleToRemove) {
        // Get the current URL
        const currentUrl = window.location.href;
        // Create a new URL object
        const urlObj = new URL(currentUrl);
        // Extract the original 'prods' parameter
        const originalProds = urlObj.searchParams.get('prods')?.split(',') || [];

        // Filter out the handle to remove
        const remainingHandles = originalProds.filter((h) => h !== handleToRemove);

        // Reconstruct the 'prods' parameter with the remaining handles
        const newProdsParam = remainingHandles.length > 0 ? remainingHandles.join(',') : '';

        // Update the URL with the modified 'prods' parameter
        urlObj.searchParams.set('prods', newProdsParam);

        // Redirect to the new URL
        window.location.href = urlObj.href;

        // Logic to remove the handle from localStorage
        // Retrieve the current allHandles array from localStorage
        let allHandles = JSON.parse(localStorage.getItem('allHandles')) || [];

        // Filter out the handle to remove
        allHandles = allHandles.filter((h) => h !== handleToRemove);

        // Update localStorage with the modified allHandles array
        localStorage.setItem('allHandles', JSON.stringify(allHandles));
    }

    async displayDataInTable(...urls) {
        try {
            let products = [];

            for (const url of urls) {
                const product = await this.fetchData(url);
                products.push(product);
            }

            const tableHeader = Array.from(
                { length: 3 },
                (_, i) =>
                    `<td class="compare-products__td compare-products__card-wrap">${this.createCard(products[i])}</td>`
            ).join('');

            const tableFooter = Array.from(
                { length: 3 },
                (_, i) =>
                    `<td class="compare-products__td compare-products__card-wrap">${this.createCard(products[i], true)}</td>`
            ).join('');

            let rowCount = 0;

            const tableDataRows = compareKeys
                .map((key) => {
                    let allEmpty = true;
                    for (let x = 0; x < 3; x++) {
                        const currentCell = products[x]?.[key];
                        // Check if currentCell is not undefined and not an empty string
                        if (currentCell !== undefined && currentCell !== '') {
                            allEmpty = false; // Found a non-empty item, so set allEmpty to false
                            break; // No need to check further since we found a non-empty item
                        }
                    }
                    if (!allEmpty) {
                        rowCount++;
                    }
                    return `
                     <tr class="large-up-hide compare-products__tr${!allEmpty ? '' : ' hidden'}">
                         <td class="compare-products__th small-hide medium-hide"><span>${key}</span></td>
                         <td class="compare-products__th" colspan="3"><span>${key}</span></td>
                     </tr>
                     <tr>
                         <td class="compare-products__th small-hide medium-hide"><span>${key}</span></td>
                         ${Array.from({ length: 3 }, (_, i) => `<td class="compare-products__td"><span>${products[i]?.[key] || ''}</span></td>`).join('')}
                     </tr>
                 `;
                })
                .join('');

            console.log('--------rowCount');
            console.log(rowCount);

            this.innerHTML = `
                <table class="compare-products__table" cellpadding="0" cellspacing="0">
                    <tr><td class="compare-products__th small-hide medium-hide"></td>${tableHeader}</tr>
                    ${tableDataRows}
                    ${rowCount >= 5 ? '' : '<tr><td class="compare-products__blank" colspan="4"></td></tr>'}
                    <tr class="${rowCount >= 5 ? '' : 'hidden'}"><td class="compare-products__th small-hide medium-hide"></td>${tableFooter}</tr>
                </table>
            `;

            this.setupRemoveButtonHandler();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    async fetchData(url) {
        return new Promise((resolve) =>
            fetch(url)
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((error) => reject(error))
        );
    }

    createCard(product, small = false) {
        let cardHtml = small ? '' : this.cardEmptyTemplate;

        if (product) {
            const { price, compare_at_price, handle, featured_image, title, url } = product;
            let priceHtml = `<span>${price}</span>`;
            let cardClass = '';

            if (
                compare_at_price !== null &&
                compare_at_price !== '$0.00' &&
                compare_at_price !== price
            ) {
                priceHtml = `<span class='price-sale'>${price}</span><span class='price-original'>${compare_at_price}</span>`;
            }

            if (small) cardClass = 'small';

            cardHtml = this.cardTemplate
                .replaceAll('#class#', cardClass)
                .replaceAll('#handle#', handle)
                .replaceAll('#image_url#', featured_image)
                .replaceAll('#title#', title)
                .replaceAll('#price#', priceHtml)
                .replaceAll('#product_url#', url);
        }

        return cardHtml;
    }
}

customElements.define('compare-products', CompareProducts);
